module.exports = __webpack_public_path__ + "img/logo-onassis-culture.f732118c.png";